import React, { useState } from 'react';
import DesktopWindow from '../components/DesktopWindow';
import { TextField, Button } from '@mui/material';

export default function ComposeWindowApp() {
  // Récupère éventuellement des données pré-remplies depuis localStorage
  const [composeData, setComposeData] = useState(() => {
    try {
      const stored = localStorage.getItem('composeData');
      return stored ? JSON.parse(stored) : { to: '', subject: '', body: '', cc: '', bcc: '' };
    } catch {
      return { to: '', subject: '', body: '', cc: '', bcc: '' };
    }
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSend = () => {
    setSending(true);
    // Ici, tu peux intégrer la logique d'envoi réelle (API, etc.)
    setTimeout(() => {
      setSending(false);
      setSent(true);
    }, 1200);
  };

  return (
    <div style={{ background: '#f5f5f5', minHeight: '100vh', padding: 0, margin: 0 }}>
      <DesktopWindow
        id="compose-window"
        title="Nouveau message"
        position={{ x: 80, y: 80 }}
        size={{ width: 500, height: 420 }}
        zIndex={2000}
        onClose={() => window.close()}
        onFocus={() => {}}
        allowFullscreen={true}
        minWidth={400}
        minHeight={320}
      >
        <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
          <TextField fullWidth label="À" value={composeData.to} onChange={e => setComposeData({ ...composeData, to: e.target.value })} sx={{ mb: 2 }} />
          <TextField fullWidth label="Sujet" value={composeData.subject} onChange={e => setComposeData({ ...composeData, subject: e.target.value })} sx={{ mb: 2 }} />
          <TextField fullWidth label="Corps" multiline minRows={4} value={composeData.body} onChange={e => setComposeData({ ...composeData, body: e.target.value })} sx={{ mb: 2 }} />
          <TextField fullWidth label="Cc" value={composeData.cc} onChange={e => setComposeData({ ...composeData, cc: e.target.value })} sx={{ mb: 2 }} />
          <TextField fullWidth label="Bcc" value={composeData.bcc} onChange={e => setComposeData({ ...composeData, bcc: e.target.value })} sx={{ mb: 2 }} />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 8 }}>
            <Button onClick={() => window.close()}>Annuler</Button>
            <Button variant="contained" onClick={handleSend} disabled={sending || sent}>{sending ? 'Envoi...' : sent ? 'Envoyé !' : 'Envoyer'}</Button>
          </div>
        </div>
      </DesktopWindow>
    </div>
  );
}
